const campaigns = [
  {
    id: 'sms_signup_2026',
    enabled: true,
    type: 'embed_form', // 'embed_form' | 'static'
    title: 'Get SMS Updates',
    description: 'Sign up for exclusive creator tips and updates via SMS.',
    formUrl:
      'https://lyodp-zgpl.maillist-manage.com/ua/Optin?od=11287ecd3bfee4&zx=13076733f&tD=115c4343b68effb91&sD=115c4343b6c2760af',
    emailEntryId: null,
    iframeHeight: '520px',
    iframeOffsetTop: -70, // Zoho form has a blank header area; negative offset hides it
    cookieDurationDays: 30,
    delayMs: 2000,
    startDate: null, // null = always active
    endDate: null,
    paths: ['/overview'], // null = all pages, array = only these paths
    privacyNotice:
      'By submitting, you agree to receive SMS messages. Msg & data rates may apply.'
  }
];

export default campaigns;
